import React from 'react';
import { propTypes } from 'react-bootstrap/esm/Image';

const RepoItem = ({ repo }) => {
  return (
    <div className='card'>
      <h3>
        <a href={repo.html_url}>{repo.name}</a>
      </h3>
      RepoItem
    </div>
  );
};

RepoItem.propTypes = {
  repo: propTypes.object,
};

export default RepoItem;
